<template>
  <div style="width: 100%">
    <div class="er_set mt20">
      <div class="er_text">用户信息</div>
      <div class="er_set_line"></div>
    </div>
    <div style="display: flex;flex-wrap: wrap;align-items: baseline;margin-top: 20px">
      <AreaCascader @loaded="onLoaded" style="width: 400px;margin-top: -3px" ref="select"/>
      <p style="margin-left: 20px">姓名：</p>
      <a-input style="width: 100px;margin-left: 20px" placeholder="请输入姓名" v-model="queryParams.name"/>
      <p style="margin-left: 20px">手机号：</p>
      <a-input style="width: 130px;" placeholder="请输入手机号" v-model="queryParams.phone"/>

      <p style="margin-left: 20px">类型：</p>
      <a-select v-model="queryParams.type" style="width: 100px;">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="7">区代表</a-select-option>
        <a-select-option value="8">镇代表</a-select-option>
        <a-select-option value="10">村民代表</a-select-option>
      </a-select>

      <a-button style="margin-left: 20px" :loading="loading" class="ml10" type="primary" @click="search">搜索</a-button>
    </div>


    <a-table ref="TableInfo"
             :columns="columns"
             :dataSource="dataSource"
             :pagination="pagination"
             :loading="loading"
             @change="handleTableChange"
             :scroll="{ x: 900 }">

      <template slot="qr" slot-scope="text, record">
        <img style="width: 50px;height: 50px" :src="'https://jinchanhb.com/qr/'+record.no" alt="">
      </template>
      <template slot="op" slot-scope="text, record">
       <a-button type="primary" @click="edit(record)">编辑</a-button>
      </template>
    </a-table>

    <user-edit
      ref="userEdit"
      @close="handleUserEditClose"
      @success="handleUserEditSuccess"
      :userEditVisiable="userEdit.visiable">
    </user-edit>

  </div>
</template>

<script>
import AreaCascader from '@/components/select/AreaCascader'
import UserEdit from './MemberEdit'
export default {
  name: 'DelegateLearning',
  components: {
    AreaCascader,UserEdit
  },
  data () {
    return {
      dataSource: [],
      loading: false,
      userEdit: {
        visiable: false
      },
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      },
      queryParams: {}
    }
  },
  computed: {
    columns() {
      let {sortedInfo, filteredInfo} = this
      sortedInfo = sortedInfo || {}
      filteredInfo = filteredInfo || {}
      return [{
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },{
        title: '姓名',
        dataIndex: 'name',
        key: 'name',
      },{
        title: '编号',
        dataIndex: 'no',
        key: 'no',
      },
        {
          title: '二维码',
          dataIndex: 'qr',
          scopedSlots: {customRender: 'qr'}
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: '区属',
          dataIndex: 'area',
          key: 'area',
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
        },

        {
          title: '操作',
          key: 'op',
          scopedSlots: {customRender: 'op'}
        }]
    }
  },
  mounted() {

  },
  methods: {
    edit(record) {
      this.userEdit.visiable = true
      this.$get('buk/no', {
        no: (record.no.toString())
      }).then((r) => {
        console.log(r);
        let data = r.data
        if (data.code != 200) {
          this.$message.error("权限不正确");
        } else {
          let res = data.data
          if (res !== undefined) {
            let id = res.id;
            let no1 = res.no1;
            let no2 = res.no2;
            record.no1 = no1;
            record.no2 = no2;
            record.bukId = id;
          }
          this.$nextTick(() => {
            this.$refs.userEdit.setFormValues(record)
          })
        }
      })
    },
    handleUserEditClose() {
      this.userEdit.visiable = false
    },
    handleUserEditSuccess() {
      this.userEdit.visiable = false
      this.$message.success('修改用户成功')
      this.search()
    },
    onLoaded() {
      this.search()
    }, search() {
      let {sortedInfo, filteredInfo} = this
      let sortField, sortOrder
      // 获取当前列的排序和列的过滤规则
      if (sortedInfo) {
        sortField = sortedInfo.field
        sortOrder = sortedInfo.order
      }
      this.fetch({
        sortField: sortField,
        sortOrder: sortOrder,
        ...this.queryParams,
        ...filteredInfo
      })
    },
    handleTableChange(pagination, filters, sorter) {
      // 将这三个参数赋值给Vue data，用于后续使用
      this.paginationInfo = pagination
      this.filteredInfo = filters
      this.sortedInfo = sorter

      this.fetch({
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...this.queryParams,
        ...filters
      })
    },
    fetch(params = {}) {
      params.streetId = this.$refs.select.getValue()
      // 显示loading
      this.loading = true
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      this.$get('lz/member/list', {
        ...params
      }).then((r) => {
        let data = r.data
        const pagination = {...this.pagination}
        pagination.total = data.total
        this.dataSource = data.rows
        this.pagination = pagination
        // 数据加载完毕，关闭loading
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.ml61 {
  margin-left: 61px;
}

.ml10 {
  margin-left: 10px;
}

.mt10 {
  margin-top: 10px;
}

.er_set {
  font-size: 17px;
  color: #333333;
  font-weight: bold;
  position: relative;
}

.mt20 {
  margin-top: 20px;
}

.er_set_line {
  width: 55px;
  height: 6px;
  background: linear-gradient(180deg, #77DDB9 0%, #42B983 100%);
  border-radius: 3px;
  position: absolute;
  bottom: 3px;
  left: 15px;
}

.er_text {
  position: relative;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/zhuluzhen/member.vue